import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "vote",
      component: () => import("@/views/edu/vote")
    },
    {
      path: "/voteContent",
      name: "voteContent",
      component: () => import("@/views/vote/content")
    },
    {
      path: "/marker",
      name: "voteMarker",
      component: () => import("@/views/marker/vote")
    },
    {
      path: "/markerContent",
      name: "markerContent",
      component: () => import("@/views/marker/content")
    },
    {
      path: "/edu",
      name: "voteEdu",
      component: () => import("@/views/edu/vote")
    },
    {
      path: "/eduContent",
      name: "eduContent",
      component: () => import("@/views/edu/content")
    },
    {
      path: "/jiugai",
      name: "voteJiugai",
      component: () => import("@/views/jiugai/vote")
    },
    {
      path: "/jiugaiContent",
      name: "contentJiugai",
      component: () => import("@/views/jiugai/content")
    },
    {
      path: "/lvdao",
      name: "votelvdao",
      component: () => import("@/views/lvdao/vote")
    },
    {
      path: "/lvdaoContent",
      name: "lvdaoContent",
      component: () => import("@/views/lvdao/content")
    } ,{
      path: "/3dmkContent",
      name: "3dmkContent",
      component: () => import("@/views/3dmk/content")
    }, {
      path: "/3dmk",
      name: "3dmaker",
      component: () => import("@/views/3dmk/vote")
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js